import React from 'react';
import i18next from 'i18next';
import Modal from 'app/components/modal';
import Calendar from 'app/components/calendar';

export default props => (
  <Modal
    title={i18next.t('home.calendar.title')}
    footer={null}
    {...props}
  >
    <Calendar fullscreen={false} />
  </Modal>
);
